module.exports = __webpack_public_path__ + "img/Fernando-Silva.43279b08.png";